import { render, staticRenderFns } from "./Multiselect.vue?vue&type=template&id=3485be26&scoped=true&"
import script from "./Multiselect.vue?vue&type=script&lang=js&"
export * from "./Multiselect.vue?vue&type=script&lang=js&"
import style0 from "./Multiselect.vue?vue&type=style&index=0&id=3485be26&prod&lang=scss&scoped=true&"
import style1 from "./Multiselect.vue?vue&type=style&index=1&id=3485be26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3485be26",
  null
  
)

export default component.exports